import { useState, type ReactNode } from 'react';
import { TicketRunningNumberPanel } from './TicketRunningNumberPanel';
import { DemSettingsPage } from '../../pages/dem/DemSettingsPage';
import { useAdminHubContext } from '../../contexts/AdminHubContext';
import { canManageDemConfigInAdminHub } from '../../lib/adminHubPermissions';

function SequenceCategory({
  title,
  count,
  children,
}: {
  title: string;
  count: number;
  children: ReactNode;
}) {
  return (
    <section className="unified-users-dept">
      <header className="unified-users-dept__head">
        <h3 className="unified-users-dept__title">{title}</h3>
        <span className="unified-users-dept__count">
          {count} {count === 1 ? 'sequence' : 'sequences'}
        </span>
      </header>
      <div className="ticket-settings-rows sequences-admin__list">{children}</div>
    </section>
  );
}

export function SequencesAdminPanel() {
  const [refreshKey, setRefreshKey] = useState(0);
  const hubCtx = useAdminHubContext();
  const actorRole = hubCtx?.actorRole ?? 'user';
  const canDem = canManageDemConfigInAdminHub(actorRole);
  const sequenceCount = 2 + (canDem ? 4 : 0);

  return (
    <section className="card settings-panel sequences-admin">
      <div className="settings-panel__head unified-users-panel__head">
        <div className="unified-users-panel__title-row">
          <h2 className="settings-panel__title">Sequences</h2>
          <div className="unified-users-panel__actions">
            <span className="settings-panel__count">
              {sequenceCount} {sequenceCount === 1 ? 'sequence' : 'sequences'}
            </span>
            <button
              type="button"
              className="btn-secondary btn-sm"
              onClick={() => setRefreshKey((n) => n + 1)}
            >
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div className="unified-users-dept-list">
        <SequenceCategory title="Sales CRM" count={1}>
          <TicketRunningNumberPanel
            key={`ticket-crm-${refreshKey}`}
            portalKind="crm"
            label="Ticket"
          />
        </SequenceCategory>

        <SequenceCategory title="IT" count={1}>
          <TicketRunningNumberPanel
            key={`ticket-it-${refreshKey}`}
            portalKind="it"
            label="Ticket"
          />
        </SequenceCategory>

        {canDem ? (
          <SequenceCategory title="DEM" count={4}>
            <DemSettingsPage
              key={`dem-${refreshKey}`}
              embeddedInAdminHub
              onlySection="sequences"
              omitSectionChrome
            />
          </SequenceCategory>
        ) : null}
      </div>
    </section>
  );
}
